module.exports = __webpack_public_path__ + "img/preinscription.6c819d70.png";